<ng-template #trainNameTemplate let-train="train" let-last="last">
  @if (train.type == 'multi' && train.subSegments) {
    @for (t of train.subSegments; track t; let last = $last) {
      <ng-container
        [ngTemplateOutlet]='trainNameTemplate'
        [ngTemplateOutletContext]='{last:last, train:t}'
      ></ng-container>
    }
  }
  @if (train.type != 'multi') {
    <div class="train-name-container">
      <div class="fx-row fx-justify-start fx-items-center" style="gap: 8px">
        @if (trainTypeImages[train.type]) {
          <img [matTooltip]="train.type" [src]="trainTypeImages[train.type]" class="train-icon"/>
        }
        <small class="train-title">{{train.name}}</small>
      </div>
      <span class="train-subtitle">{{subTitle(train)}}</span>
    </div>
  }
  @if (!last) {
    <div class="train-separator"> + </div>
  }
</ng-template>

<ng-template #gridCellBodyPrice let-isSelected="isSelected" let-price="price" let-totalPriceNet = "totalPriceNet" let-fee="fee" let-availableAmount="availableAmount" let-trainid="trainid" let-rowid="rowid" let-colid="colid">
  <div class="grid-cell grid-body-cell"
    (click)="availableAmount > 0 ? priceSelect(rowid, colid, trainid) : null;"
    [ngClass]="{'grid-body-cell-selected': isSelected, 'cursor-pointer': availableAmount>0}"
    >
    @if (availableAmount != 0) {
      <span class="font-size-12 font-weight-600"
        matTooltip="{{fee>0?'Prezzo:'+ (totalPriceNet| currency:'EUR':'symbol':'1.2-2')+' + Diritti agenzia: '+(fee| currency:'EUR':'symbol':'1.2-2'):''}}">
        {{price | currency:'EUR':'symbol':'1.2-2'}}
      </span>
    }
    @if (availableAmount == 0) {
      <span class="font-size-12 font-weight-600">Esaurito</span>
    }
  </div>
</ng-template>

@for (train of travelSolution.trains; track indexTrackBy(k, train); let k = $index; let last = $last) {
  <div>
    <!--se con cambio mostro le tratte-->
    <div class="fx-row fx-wrap fx-justify-start fx-items-center" style="gap:8px; margin-top:20px">
      <ng-container
        [ngTemplateOutlet]='trainNameTemplate'
        [ngTemplateOutletContext]='{last:true, train:train}'
      ></ng-container>
    </div>
    <div class="font-size-14 font-weight-600 text-color-black mb-4 mt-4">Seleziona servizio e offerta</div>
    @if (loading) {
      <mat-progress-bar mode='indeterminate'></mat-progress-bar>
    }
    @if (!otherOffer) {
      <div>
        @if (templateGridData[train.id]) {
          <div class="flex-col flex-gap-2">
            <div class="row flex-row flex-gap-2">
              <div style="flex-basis:16.666667%"></div>
              @for (colData of templateGridData[train.id].cols; track indexTrackBy(c, colData); let c = $index) {
                <div
                  class="column-header grid-cell"
                  [ngClass]="{'sel': colData.isSelected}"
                  >
                  {{colData.col.display_name}}
                </div>
              }
              <br>
              </div>
              @for (rowData of templateGridData[train.id].rows; track indexTrackBy(r, rowData); let r = $index) {
                <div class="row flex-row flex-gap-2">
                  <div class="row-header" [ngClass]="{'sel-r': rowData.isSelected}">
                    {{rowData.row.display_name}}
                    <span class="info-icon" (click)="openInfo(rowData.row.display_name)">
                      <mat-icon>info</mat-icon>
                    </span>
                  </div>
                  @for (colData of templateGridData[train.id].cols; track indexTrackBy(c, colData); let c = $index) {
                    @if (templateGridData[train.id].matrix[rowData.id][colData.id].hasPrice) {
                      <ng-container
                        [ngTemplateOutlet]="gridCellBodyPrice"
                      [ngTemplateOutletContext]="templateGridData[train.id].matrix[rowData.id][colData.id]"></ng-container>
                    }
                    @if (!templateGridData[train.id].matrix[rowData.id][colData.id].hasPrice) {
                      <div class="grid-cell"></div>
                    }
                  }
                </div>
              }
            </div>
          }
          @if (priceGrid[train.id] && priceGrid[train.id].priceSelected && priceGrid[train.id].priceSelected.row) {
            @if (_trnService.servicesMap.value.offers[priceGrid[train.id].priceSelected.row].description) {
              <div class="row" class="description"
                >
                <h2>{{_trnService.servicesMap.value.offers[priceGrid[train.id].priceSelected.row].display_name}}</h2>
                <span>{{_trnService.servicesMap.value.offers[priceGrid[train.id].priceSelected.row].description}}</span>
              </div>
            }
            <div class="row">
              <span class="mr-16">
                @if (_trnService.servicesMap.value.offers[priceGrid[train.id].priceSelected.row].can_change) {
                  <span
                    style="color:#93B733"
                    >
                    <mat-icon>check_circle</mat-icon> <strong>Cambio</strong></span>
                  }
                  @if (!_trnService.servicesMap.value.offers[priceGrid[train.id].priceSelected.row].can_change) {
                    <span
                      style="color:red"
                      ><mat-icon
                      color="warn">remove_circle</mat-icon> <strong>Cambio</strong></span>
                    }
                  </span>
                  <span >
                    @if (_trnService.servicesMap.value.offers[priceGrid[train.id].priceSelected.row].can_refund) {
                      <span
                        style="color:#93B733"
                        ><mat-icon>check_circle</mat-icon> <strong>Rimborso</strong></span>
                      }
                      @if (!_trnService.servicesMap.value.offers[priceGrid[train.id].priceSelected.row].can_refund) {
                        <span
                          style="color:red"
                          >
                          <mat-icon>remove_circle</mat-icon> <strong>Rimborso</strong></span>
                        }
                      </span>
                    </div>
                  }
                  @if (checkCF(priceGrid[train.id])) {
                    <div class="row fx-row fx-wrap" style="gap: 8px">
                      @for (s of travelSolution.travellers; track s; let i = $index) {
                        <div>
                          <mat-form-field appearance="outline">
                            <mat-label><span>CartaFRECCIA {{+i +1}}</span></mat-label>
                            <input
                              matInput placeholder="CartaFRECCIA" autocomplete="off"
                              type='text' [(ngModel)]="s.cartaFreccia" maxlength="30" required>
                            <mat-hint>Obbligatoria</mat-hint>
                          </mat-form-field>
                        </div>
                      }
                    </div>
                  }
                  @if (last) {
                    <div class="row other-offer">
                      <button mat-stroked-button (click)="setOtherOffer()" >Vedi altre offerte</button>
                    </div>
                  }
                </div>
              }
              @if (otherOffer && customTravelSolution) {
                <div>
                  <trenitalia-other-solution
                    [solution]="customTravelSolution"
                    [train]="train"
                    [errors]="errors[train.id]"
                  (custom-offer-select-price)="onCustomOfferPriceSelected($event)"></trenitalia-other-solution>
                  @if (!travelSolution.require_offer_map && last) {
                    <div class="row" style="margin-top: 8px;margin-bottom: 16px;">
                      <button mat-button (click)="backToGrid()" color="">Torna alla griglia</button>
                    </div>
                  }
                </div>
              }
              @if (!last) {
                <mat-divider></mat-divider>
              }
            </div>
          }